import { doVectorSearch } from "../../search"

// Every source of the tool is searched with the same query. One entry per document, so the trace can count them
export function searchTool(config: Extract<PlaybookToolConfig, { type: "search" }>, index: number, keys: APIKeys, team: string): PlaybookTool {
  return {
    name: `search_${index}`,
    description: config.description,
    parameters: { type: "object", properties: { query: { type: "string", description: "Short and specific, 3 to 6 words" } }, required: ["query"] },
    run: async ({ query }) => {
      const results = await Promise.all((config.sources || []).map(s => doVectorSearch({
        type: s.type, query, limit: s.results, keys, distance: s.distance, locale: s.locale, domain: s.domain,
        chunked: s.chunked, sources: s.sources, url: s.url, baseUrl: s.baseUrl, team,
      })))
      const docs = results.flat().filter(Boolean) as VectorDocument[]
      return docs.length ? docs.map(toText) : "Nothing found."
    },
  }
}

// Our own documents carry no public link worth showing
function toText(doc: VectorDocument) {
  const text = `Title: ${doc.title}\nContent: ${doc.body}`
  return doc.origin === "supabase" ? text : `${text}\nLink: ${doc.source}`
}
